<template funtional>
  <h2 class="font-bold main-list-title text-dark select-none" >
    <slot></slot><span v-if="!hideAdd" :class="trackClass" class="cursor-pointer hover:text-warning" @click.stop="$emit('click')">&nbsp;+</span>
  </h2>
</template>

<script>
export default {
  props: ['hideAdd', 'trackClass'],
  computed: {
    isMobile () {
      // return true
      return this.$store.getters.isMobile || this.windowWidth <= 1024
    },
  }
}
</script>


<style>


.main-list-title {
  font-size: 3rem;
}

@media screen and (min-width: 450px) {
  .main-list-title {
    font-size: 4rem;
  }
}

</style>
